import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";

const FavCtx = createContext(null);
export const useFavorites = () => useContext(FavCtx);

export function FavoritesProvider({ children }) {
  const { user } = useAuth();
  const [favs, setFavs] = useState([]);

  const load = useCallback(async () => {
    if (!user) { setFavs([]); return; }
    try { const r = await api.get("/favorites"); setFavs(r.data.results || []); } catch { /* silent */ }
  }, [user]);

  useEffect(() => { load(); }, [load]);

  const isFav = (kind, ref_id) => favs.some(f => f.kind === kind && String(f.ref_id) === String(ref_id));

  const toggle = async (item) => {
    if (!user) { toast.error("PILOT AUTHENTICATION REQUIRED"); return; }
    try {
      const r = await api.post("/favorites", item);
      if (r.data.status === "added") {
        toast.success("ARCHIVED TO ARSENAL");
        setFavs(prev => [r.data.favorite, ...prev]);
      } else {
        toast("REMOVED FROM ARCHIVE");
        setFavs(prev => prev.filter(f => !(f.kind === item.kind && String(f.ref_id) === String(item.ref_id))));
      }
    } catch (e) { toast.error("TRANSMISSION FAILED"); }
  };

  const remove = async (fav_id) => {
    try { await api.delete(`/favorites/${fav_id}`); setFavs(prev => prev.filter(f => f.id !== fav_id)); }
    catch { toast.error("REMOVAL FAILED"); }
  };

  return <FavCtx.Provider value={{ favs, isFav, toggle, remove, reload: load }}>{children}</FavCtx.Provider>;
}
